module.exports = __webpack_public_path__ + "img/GP2_Germany_GreenTechBW.59156f2a.jpeg";